enum formActionType {
    NAMEPLATE_INPUT = 'NAMEPLATE_INPUT',
    MESSAGE_INPUT = 'MESSAGE_INPUT',
    START_FORM_STAGE = 'START_FORM_STAGE',
    GO_TO_FORM_STAGE = 'GO_TO_FORM_STAGE',
    RESET_FORM_STAGE = 'RESET_FORM_STAGE',
    LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL',
    LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL',
    SET_START_TIME = 'SET_START_TIME',
    REFRESH_STAGE = 'REFRESH_STAGE',
    SET_SCREEN = 'SET_SCREEN',
    SET_USERNAME = 'SET_USERNAME',
}

export default formActionType